module.exports = __webpack_public_path__ + "img/icon-dictionary.c0a628fa.svg";